import { styled } from 'styled-components';

import { Image } from 'app/components/image';

export const StyledArrowRight = styled(Image)`
    width: 12px !important; /* stylelint-disable-line declaration-no-important */
    height: 12px !important; /* stylelint-disable-line declaration-no-important */
`;
